import { useCallback } from 'react';
import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { useLocale } from '../../context/LocaleContext';

export function useViewModel({ parentId, imageUrl, title, description, price, variantId }) {
  const { setGiftInfo, activePersonalisation, setActivePersonalisation, wrapOptions, personalisationChoices } =
    useGiftWrapContext();
  const { formatPrice } = useLocale();

  // Determine if this item is selected (only for variants, not main items)
  const isSelected = () => {
    if (variantId) {
      // For variants, check if this specific variant is selected in personalisationChoices
      const selectedChoice = personalisationChoices.find((choice) => choice.parentId === parentId);
      return selectedChoice?.vId_gift === variantId;
    } else {
      // For main items, don't show selection highlighting (handled at container level)
      return false;
    }
  };

  const handleClickGiftInfo = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (variantId !== null) return;

      // Handle click event for gift info
      setGiftInfo({
        title,
        description,
        imageUrl,
        price
      });
    },
    [title, description, imageUrl, price]
  );

  const handleClick = () => {
    if (variantId !== null) return;

    setGiftInfo(null);
    if (activePersonalisation.parentId !== '') {
      setActivePersonalisation({
        type: 'box',
        parentId: '',
        vId_gift: '',
        text: null,
        vId_stamp: null,
        vId_stamp_label: null,
        title: null,
        price: null
      });
    }

    // Find to see if was already selected
    let personalisation = personalisationChoices.find((o) => o.parentId === parentId);
    if (personalisation) {
      setActivePersonalisation(personalisation);
      return;
    }
    // If not look in wrap options
    const wrapOption = wrapOptions.find((o) => o.product_id === parentId);
    if (wrapOption) {
      const rawType = wrapOption.type;
      // Map unsupported types to a valid one
      const allowedTypes = ['bag', 'box', 'card'];
      let type = allowedTypes.includes(rawType) ? rawType : 'bag';

      setActivePersonalisation({
        type,
        parentId: wrapOption.product_id,
        vId_gift: wrapOption.variants?.[0]?.id,
        text: null,
        vId_stamp: null,
        vId_stamp_label: null
      });
    }
  };
  return {
    handleClickGiftInfo,
    handleClick,
    formatPrice,
    isSelected: isSelected()
  };
}
